import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
  standalone: false,
  selector: 'suvo-bi-clear-control-button',
  templateUrl: './clear-control-button.component.html',
  styleUrls: ['./clear-control-button.component.scss'],
})
export class ClearControlButtonComponent {
  @Input() clearFormGroup: FormGroup;
  @Input() clearFormControlName?: string;
}
